// AttendanceFlowChart.js

import React, { useState } from 'react';
import {
  Box,
  Card,
  CardHeader,
  // Tabs,
  // Tab,
} from '@mui/material';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

/*
const data = [
  { hour: '09:00 - 09:59', converted: 0, attended: 1 },
  { hour: '10:00 - 10:59', converted: 2, attended: 5 },
  { hour: '11:00 - 11:59', converted: 3, attended: 9 },
  { hour: '12:00 - 12:59', converted: 3, attended: 11 },
  { hour: '13:00 - 13:59', converted: 4, attended: 12 },
  { hour: '14:00 - 14:59', converted: 12, attended: 28 },
  { hour: '15:00 - 15:59', converted: 14, attended: 31 },
  { hour: '16:00 - 16:59', converted: 7, attended: 14 },
  { hour: '17:00 - 17:59', converted: 7, attended: 16 },
  { hour: '18:00 - 18:59', converted: 7, attended: 20 },
  { hour: '19:00 - 19:59', converted: 6, attended: 22 },
  { hour: '20:00 - 20:59', converted: 4, attended: 18 },
  { hour: '21:00 - 21:59', converted: 1, attended: 3 },
  { hour: '22:00 - 22:59', converted: 1, attended: 2 },
];
*/

export default function AttendanceFlowChart({ operations }) {
  const [
    tab, 
    // setTab,
  ] = useState(0);
  const userTimezone = dayjs.tz.guess();

  // const handleTabChange = (event, newValue) => {
  //   setTab(newValue);
  // };

  function processOperations(operations) {
    const resultMap = new Map();

    operations.forEach(op => {
      if (!op.finished_at) return;

      // Converte para data local no navegador
      // Usa dayjs com timezone
      const localDate = dayjs.utc(op.finished_at).tz(userTimezone);
      const localHour = localDate.format('HH');
      const hourRange = `${localHour}:00 - ${localHour}:59`;

      if (!resultMap.has(hourRange)) {
        resultMap.set(hourRange, { hour: hourRange, converted: 0, attended: 0 });
      }

      const hourData = resultMap.get(hourRange);
      hourData.attended += 1;

      if (op.to_status === "inService" && op.finish_reason === "sucesso") {
        hourData.converted += 1;
      }
    });

    // Ordena pelas horas crescentemente
    return Array.from(resultMap.values()).sort((a, b) => {
      const hourA = parseInt(a.hour.split(':')[0], 10);
      const hourB = parseInt(b.hour.split(':')[0], 10);
      return hourA - hourB;
    });
  }

  return (
    <Card sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
      <CardHeader title="Fluxo de atendimento" />

      {/* <Tabs value={tab} onChange={handleTabChange} sx={{ mb: 2 }}>
        <Tab label="Oportunidade" />
        <Tab label="Conversão" />
      </Tabs> */}

      {tab === 0 && (
        <ResponsiveContainer width="100%" height={400}>
          <AreaChart data={processOperations(operations)} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
            <defs>
              <linearGradient id="colorConverted" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#60c765" stopOpacity={0.4} />
                <stop offset="95%" stopColor="#60c765" stopOpacity={0} />
              </linearGradient>
              <linearGradient id="colorAttended" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#ff7300" stopOpacity={0.4} />
                <stop offset="95%" stopColor="#ff7300" stopOpacity={0} />
              </linearGradient>
            </defs>
            <XAxis dataKey="hour" />
            <YAxis />
            <CartesianGrid strokeDasharray="3 3" />
            <Tooltip
              formatter={(value, name) => {
                const translatedLabels = {
                  attended: 'Atendidos',
                  converted: 'Convertidos',
                };
                return [value, translatedLabels[name] || name];
              }}
            />
            <Area
              type="monotone"
              dataKey="attended"
              stroke="#ff7300"
              fill="url(#colorAttended)"
              strokeWidth={3}
              activeDot={{ r: 5 }}
            />
            <Area
              type="monotone"
              dataKey="converted"
              stroke="#60c765"
              fill="url(#colorConverted)"
              strokeWidth={3}
              activeDot={{ r: 5 }}
            />
          </AreaChart>
        </ResponsiveContainer>
      )}

      {tab === 1 && (
        <Box p={2} textAlign="center">
          <em>Conversion view not implemented yet.</em>
        </Box>
      )}
    </Card>
  );
}
